/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { queryOptions, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys } from "./queryKeys";

export const translationQueryOptions = (lang, queryParams) =>
  queryOptions({
    queryKey: queryKeys.translation.byLang(lang),
    queryFn: () => fetcher({ method: "GET", url: "/public/lang", params: { lang } }),
    staleTime: Infinity,
    ...queryParams,
  });

export const useTranslation = (lang, queryParams) => useQuery(translationQueryOptions(lang, queryParams));
export const useSuspenseTranslation = (lang, queryParams) => useSuspenseQuery(translationQueryOptions(lang, queryParams));
